import React, { memo } from "react";
import classNames from "classnames";

import "./IndeterminateCheckbox.scss";

import CheckedIcon from "static/icons/checked.svg";
import IndeterminateIcon from "static/icons/indeterminate.svg";

const IndeterminateCheckbox = ({
  label,
  handleChange,
  name,
  checked,
  indeterminate,
  disabled,
}) => (
  <label className="universal-checkbox">
    <input
      type="checkbox"
      name={name}
      checked={checked || indeterminate}
      onChange={handleChange}
      disabled={disabled}
    />

    <div
      className={classNames({
        "universal-checkbox__indicator": true,
        "universal-checkbox__indicator--checked": checked,
        "universal-checkbox__indicator--indeterminate": indeterminate,
      })}
    >
      {checked ? (
        <img alt="CheckedIcon" src={CheckedIcon} />
      ) : indeterminate ? (
        <img alt="IndeterminateIcon" src={IndeterminateIcon} />
      ) : null}
    </div>

    {label}
  </label>
);

export default memo(IndeterminateCheckbox);
